// Backend stores all monetary amounts in a currency's smallest units.
// With currency precision = 2, one major unit equals 100 smallest units.
// All store/network values keep this raw integer representation; the helpers
// here convert to/from the major unit only at the display boundary.

export const CURRENCY_PRECISION = 2
export const MINOR_PER_MAJOR = Math.pow(10, CURRENCY_PRECISION)

/** Format a smallest-unit amount as a fixed-decimal major-unit string.
 *  e.g. fromMinor(475) => "4.75" */
export function fromMinor(amountMinor: number, decimals = CURRENCY_PRECISION): string {
  if (!Number.isFinite(amountMinor)) return '0.00'
  return (amountMinor / MINOR_PER_MAJOR).toFixed(decimals)
}

/** Convert major-unit number to smallest units (e.g. 5 => 500). */
export function toMinor(amountMajor: number): number {
  return Math.round(amountMajor * MINOR_PER_MAJOR)
}

/** Resolve the standard narrow symbol for a session currency, falling back to its code. */
export function currencyDisplayFromCode(currencyCode: string): string {
  const normalizedCode = currencyCode.trim().toUpperCase()
  if (!normalizedCode) return ''

  try {
    const currencyPart = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: normalizedCode,
      currencyDisplay: 'narrowSymbol',
    }).formatToParts(0).find((part) => part.type === 'currency')

    return currencyPart?.value || normalizedCode
  } catch {
    return normalizedCode
  }
}
